<h1 class="title">Dashboard<i class="fa" [ngClass]="{'fa-chain':(dashboardOnline | async), 'fa-chain-broken':(!(dashboardOnline | async))}"></i></h1>
@if (!(ap | async)) {
  <span>Loading...</span>
}

<div class="grid flex-row justify-content-start overview-content">
  <div class="col-9 grid flex-column left-panel">
    <div class="grid flex-row display-row">
      @for (disp of (ap | async)?.displays; track disp) {
        <p-panel class="col-5 bacdisplay baccard">
          <p-header class="title">
            <i class="fa fa-tv"></i>{{ disp.display }}
          </p-header>
          <ul>
            <li>{{ disp.line1 }}</li>
            <li>{{ disp.line2 }}</li>
          </ul>
        </p-panel>
      }
    </div>
    <div class="areas-grid">
      @for (area of (areas | async); track area) {
        <div class="bacarea baccard">
          <div class="card-header">
            <span class="card-title">{{ area.name }}</span>
            <span class="controllers">
              @for (ctrl of area.entries; track ctrl) {
                <span class="baccontroller">{{ ctrl.entry }}:<i class="fa"
                                                                [ngClass]="{'fa-chain':ctrl.online, 'fa-chain-broken':(!ctrl.online)}"></i>
              </span>
              }
            </span>
          </div>
          <ul class="card-content">
            @for (car of area.cars; track car) {
              <li
                pTooltip="<table>
              <tr><td>License plate:</td><td>{{car.licensePlate}}</td></tr>
              <tr><td>Company:</td><td>{{car.company?.name}}</td></tr>
              </table>"
                tooltipPosition="top" [escape]="ttEscape" tooltipStyleClass="car-tooltip">
                <i class="fa fa-cab" [ngClass]="{'car-blacklisted': car.blacklisted}"></i>{{ car.licensePlate }} ({{ car.carCalledAt | date:'HH:mm:ss' }}{{ car.shortTrip ? ' - st' : '' }})
                @if (-1 !== car.carFeatures.indexOf('BREAK')) {
                  <i class="fa fa-truck"></i>
                }
                @if (-1 !== car.carFeatures.indexOf('PRM')) {
                  <i class="fa fa-credit-card"></i>
                }
                @if (-1 !== car.carFeatures.indexOf('MINIVAN')) {
                  <i class="fa fa-bus"></i>
                }
                @if (-1 !== car.carFeatures.indexOf('TWALTER')) {
                  <i>TW</i>
                }
                @if (-1 !== car.carFeatures.indexOf('UNITAX')) {
                  <i>UT</i>
                }
                @if (-1 !== car.carFeatures.indexOf('AUTOTAX')) {
                  <i>AL</i>
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>

  <div class="col-3 right-panel">
    @if (false) {
      <p-panel class="col-12 sensors baccard">
        <p-header class="title">
          Sensors
        </p-header>
        <div fxLayout="row" fxLayoutAlign="center">
          <div fxLayout="row" fxLayoutAlign="space-evenly" fxLayoutWrap fxFlex="1 1 auto">
            @for (s of sensits | async; track s) {
              <span fxFlex="1 0 20%" class="fa fa-podcast" [ngClass]="{'free':s, 'busy':!s}"></span>
            }
          </div>
          <div fxFlex="0 1 auto" class="sas" fxLayout="row" fxLayoutAlign="center center">
            <span>SAS</span>
          </div>
        </div>
      </p-panel>
    }
    <div class="alerts baccard">
      <div class="card-header">
        Alert messages
      </div>
      <div class="card-content">
        <ul>
          @for (alert of alerts | async; track alert) {
            <li class="bacalert">
              <i class="fa" [ngClass]="{'fa-info-circle':(alert.type==='INFO'), 'fa-warning':(alert.type==='WARN')}"></i>
              <span class="datetime">{{ alert.timestamp | date:'short' }}</span> {{ alert.message }}
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
  @if (false) {
    <div class="col-2">
      <p-panel class="col-12 bacarea baccard offsite">
        <p-header class="title">
          {{ (offsite|async)?.name }}
          <ul class="pull-right">
            @for (ctrl of ((offsite|async)?.entries || []); track ctrl) {
              <li class="baccontroller">{{ ctrl.entry }}:<i class="fa"
                                                            [ngClass]="{'fa-chain':ctrl.online, 'fa-chain-broken':(!ctrl.online)}"></i>
              </li>
            }
          </ul>
        </p-header>
        <ul>
          @for (car of (offsite|async)?.cars; track car) {
            <li pTooltip="<table>
                <tr><td>License plate:</td><td>{{car.licensePlate}}</td></tr>
                <tr><td>Company:</td><td>{{car.company?.name}}</td></tr>
                </table>"
                tooltipPosition="top" [escape]="ttEscape" tooltipStyleClass="car-tooltip">
              <i class="fa fa-cab" [ngClass]="{'car-blacklisted': car.blacklisted}"></i>{{ car.licensePlate }} ({{ car.carCalledAt }})
              @if (-1 !== car.carFeatures.indexOf('BREAK')) {
                <i class="fa fa-truck"></i>
              }
              @if (-1 !== car.carFeatures.indexOf('PRM')) {
                <i class="fa fa-credit-card"></i>
              }
              @if (-1 !== car.carFeatures.indexOf('MINIVAN')) {
                <i class="fa fa-bus"></i>
              }
              @if (-1 !== car.carFeatures.indexOf('TWALTER')) {
                <i>TW</i>
              }
              @if (-1 !== car.carFeatures.indexOf('UNITAX')) {
                <i>UT</i>
              }
              @if (-1 !== car.carFeatures.indexOf('AUTOTAX')) {
                <i>AL</i>
              }
            </li>
          }
        </ul>
      </p-panel>
    </div>
  }


</div>
